<template>
  <menu class="menu"
    :class="modifierClass ? `menu--${modifierClass}` : ''"
    :data-expand="expanded || (isMenuOpen && isNotSync)">

    <button class="menu__button" v-on:click.stop="toggle" :data-acc="acc">
      <figure :class="figureClass" :style="image ? `background-image:url(${image})` : ''"></figure>
      <span class="menu__label">{{ label }}</span>
    </button>

    <ul class="menu__tray">
      <li class="menu__item" v-for="link in links">
        <router-link :to="link.url" v-if="!link.bypassRouter" :data-acc="link.acc">
          {{ link.label }}
        </router-link>

        <a href="javascript:void(0)" v-on:click="throwFunction(link.url)" :data-acc="link.acc" v-else-if="link.asFunction">
          {{ link.label }}
        </a>

        <a :href="link.url" :data-acc="link.acc" v-else>
          {{ link.label }}
        </a>
      </li>
    </ul>
  </menu>
</template>

<script>
import _dom from 'modules/_dom'

export default {
  name: 'dropdown',
  props: {
    index: [String, Number],
    modifierClass: String,
    figureClass: String,
    image: String,
    label: String,
    links: Array,
    expanded: Boolean,
    isNotSync: Boolean,
    acc: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isMenuOpen: this.expanded
    }
  },
  methods: {
    throwFunction(event) {
      this.$emit(event)
    },
    domHandler: function() {
      _dom.off(['click', 'scroll'], this.domHandler)
      this.hasOpenMenu = false
      this.$store.commit('menu/CLOSE')
    },
    toggle: function() {
      // always keep dropdown in sync with state
      if (!this.isNotSync) {
        this.isMenuOpen = this.expanded
      }
      // trigger close for all menu when we want to open one
      if (!this.isMenuOpen && !this.isNotSync) {
        this.$store.commit('menu/CLOSE')
      }
      if (!this.isMenuOpen) {
        _dom.on(['click', 'scroll'], this.domHandler)
        if (!this.isNotSync) {
          this.$store.commit('menu/CLOSE')
          this.$store.commit('menu/TOGGLE', this.index)
        }
        this.isMenuOpen = true
      } else {
        _dom.off(['click', 'scroll'], this.domHandler)
        if (!this.isNotSync) {
          this.$store.commit('menu/CLOSE')
        }
        this.isMenuOpen = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sass/tools';

.menu {
  position: relative;
  height: 100%;
  display: flex;
  align-items: stretch;
  @include menu-text;

  &--lighter {
    color: cc(label);
  }

  &__button {
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 1.75rem;
    background-color: cc(bg);
    z-index: 2;

    .icon {
      margin-right: .75rem;
      font-size: 1.25em;
    }
  }

  &__label {
    transition: all 150ms cb(io);
    position: relative;
    margin-right: 2rem;
    padding-right: 1.25rem;
    backface-visibility: hidden;

    [data-expand='true'] & {
      color: cc(primary);
    }

    &::before,
    &::after {
      content: '';
      transition: transform 175ms cb();
      position: absolute;
      top: 25%;
      width: 3px;
      height: .6rem;
      background-color: currentColor;
    }

    &::before {
      right: 0;
      transform: rotate(45deg);
      transform-origin: 100% 100%;

      [data-expand='true'] & {
        transform: translate(-100%,-75%) rotate(135deg);
      }
    }

    &::after {
      left: 100%;
      transform: rotate(-45deg);
      transform-origin: 0 100%;

      [data-expand='true'] & {
        transform: translate(50%,-75%) rotate(-135deg);
      }
    }
  }

  &__tray {
    transition: box-shadow 200ms cb() 125ms;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: cc(bg);
    overflow: hidden;
    pointer-events: none;
    @include boxShadow(0);

    [data-expand='true'] & {
      pointer-events: auto;
      z-index: 3;
      @include boxShadow;
    }
  }

  &__item {
    position: relative;
    transition: margin-top 200ms cb(io), padding 175ms cb() 150ms;
    line-height: 2.25rem;
    vertical-align: middle;
    margin-top: -2.25rem;
    padding-left: 1.75rem;
    background-color: inherit;

    &::before {
      transition: all 200ms cb();
      content: '';
      position: absolute;
      left: .75rem;
      top: 50%;
      size: 0;
      border-top: .25em solid transparent;
      border-bottom: .25em solid transparent;
      border-left: .5em solid cc(border);
      transform: translateY(-50%) scale(0);
      transform-origin: 100% 50%;
    }

    &:hover::before {
      transform: translateY(-50%) scale(1);
    }

    a {
      display: block;
      line-height: inherit;
      vertical-align: inherit;
    }

    [data-expand='true'] & {
      margin-top: 0;

      &:first-child {
        padding-top: .5em;

        &::before {
          margin-top: .25em;
        }
      }

      &:last-child {
        padding-bottom: 1em;

        &::before {
          margin-top: -.5em;
        }
      }
    }
  }

  &__figure {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 50px;
    margin-right: 1rem;
    border-radius: 50%;
    background-color: cc(bg,alt);
    @include bgCover;
  }
}
</style>



// WEBPACK FOOTER //
// Dropdown.vue?268af666